import React, { Component } from 'react'
import { connect } from 'react-redux'

import Select from 'react-select'

import { pageUpdateTimezone, pageToggleIgnoreCalendars, pageSetPreferredTimes } from '../../../store/pages-management/actions'

import './../Tabs/Editor/Editor.scss'
import './Availabilities.scss'
import Ranges from '../../../Components/ranges/Ranges'

const CheckBox = (props) => {
  return (
    <div
      className={props.selected ? 'checkbox selected' : 'checkbox'}
      onClick={() => {
        props.onToggle()
      }}
      role="presentation"
    >
      <div className="dot" />
    </div>
  )
}

class Availabilities extends Component {
  constructor(props) {
    super(props)
  }
  renderIgnorecalendars() {
    const { strings } = this.props
    return (
      <div className="part head ignorecals">
        <h3 className="part_header">{strings.ignore_calendars}</h3>
        <div>
          <span>
            {strings.ignore_calendars_explanation_1}
            <br /> {strings.ignore_calendars_explanation_2}
          </span>
          <div className="checkbox_section">
            <CheckBox
              selected={this.props.page.ignore_calendars}
              onToggle={() => {
                this.props.toggleIgnoreCalendars()
              }}
            />
          </div>
        </div>
      </div>
    )
  }

  renderRanges() {
    const { page, strings } = this.props

    return (
      <div className="part head">
        <h3 className="part_header">{strings.preferred_times}</h3>
        <p>
          {strings.preferred_times_explanation}
          <br />
          <br />
        </p>
        <Ranges ranges={ page.preferred_times } save={(ranges) => this.props.updatePreferredTimes(ranges)} />
      </div>
    )
  }

  renderTimeZone() {
    const { page, strings } = this.props

    return (
      <div className="part head">
        <h3 className="part_header">{strings.preferred_timezone}</h3>
        <div className="timezone">
          <Select
            name="timezone"
            value={{ label: page.timezone }}
            options={[{ label:'London', value:'Europe/London' },{ label: 'GMT', value: 'GMT' },{ label:'New_York', value:'America/New_York' },{ label:'Brussels', value:'Europe/Brussels' }]}
            onChange={(event) => {
              this.props.updateTimezone(event.value)
            }}
            required
          />
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="availabilities">
        {this.renderRanges()}
        <hr />
        {this.renderIgnorecalendars()}
        <hr />
        {this.renderTimeZone()}
        <hr />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const page =
    state.pagesManagement.active_company && state.pagesManagement.active_page
      ? state.pagesManagement.companies
        .find(
          (company) => company.id === state.pagesManagement.active_company,
        )
        .pages.find((page) => page.id === state.pagesManagement.active_page)
      : null

  return {
    page: page,
    ranges: page ? page.preferred_times : [],
    companies: state.pagesManagement.companies,
    company: state.pagesManagement.active_company
      ? state.pagesManagement.companies.find(
        (company) => company.id === state.pagesManagement.active_company,
      )
      : null,
    strings: state.languages.strings.pages.availabilities,
    isFetching: state.pagesManagement.isFetching,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateTimezone: (tz) => dispatch(pageUpdateTimezone(tz)),
    updatePreferredTimes: (ranges) => dispatch(pageSetPreferredTimes(ranges)),
    toggleIgnoreCalendars: () => dispatch(pageToggleIgnoreCalendars()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Availabilities)
